import React from 'react';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { StyledInstructionItem, InstructionContent } from './index.style';

const InstructionItem = ({ title, description }) => (
  <StyledInstructionItem>
    <CheckRoundedIcon
      sx={{ width: '24px', height: '24px', color: COLOR.indigo[80] }}
    />
    <InstructionContent>
      <Typography variant="body-16-bold" color={COLOR.darkGray}>
        {title}
      </Typography>
      <Typography variant="body-14-regular" color={COLOR.label2[64]}>
        {description}
      </Typography>
    </InstructionContent>
  </StyledInstructionItem>
);

export default InstructionItem;
